import useEditingStore from '@hooks/useEditingStore';
import useTemplateFeature from '@hooks/useTemplateFeature';
import { $curScene, $tourData } from '@stores/dataStores';
import {
  $GateSearchBtn,
  $editingFlag,
  $editingLangFlag,
} from '@stores/editingStores';
import { $isCn } from '@stores/langStores';
import { SceneType } from '@types';
import { useStore } from 'effector-react';
import ImgCN from './img-cn.png';
import ImgEN from './img-en.png';
import ImgFS from './img-fullscreen.png';
import ImgHotspot from './img-hotspot.png';
import ImgSearch from './img-search.png';
import ImgSwitch from './img-switch.png';
import ImgVR from './img-vr.png';

function WFeatureToggles() {
  const isMatrix = useStore($curScene)?.type === SceneType.matrix;
  const isCn = useStore($isCn);
  const langFeature = useTemplateFeature('language');
  const searchFeature = useTemplateFeature('searchSetting');
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });
  const langFlag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.config?.language?.showButton,
    $editing: $editingLangFlag.store,
  });
  const showSearch = useEditingStore({
    $data: $tourData,
    dataFn: (state) => !!state.config?.search?.enabled,
    $editing: $GateSearchBtn.state,
  });

  const showFS = !!(flag?.showFullscreenBtn ?? 1);
  const showVR = !!(flag?.showVRBtn ?? 1) && !isMatrix;
  const showVS = !!(flag?.showViewSwitchBtn ?? 1) && !isMatrix;
  const showLang = langFeature && !!(langFlag ?? 0);
  const showHotspotBtn = !!(flag?.showHotspotBtn ?? 0);

  const renderIcon = (src: string) => (
    <img draggable={false} src={src} alt="" className="mb-10 h-32 w-32" />
  );

  return (
    <div className="absolute right-15 top-15 flex flex-col">
      {showFS && renderIcon(ImgFS)}
      {showHotspotBtn && renderIcon(ImgHotspot)}
      {showVR && renderIcon(ImgVR)}
      {showVS && renderIcon(ImgSwitch)}
      {showLang && renderIcon(isCn ? ImgEN : ImgCN)}
      {showSearch && searchFeature && renderIcon(ImgSearch)}
    </div>
  );
}

export default WFeatureToggles;
